import { Component, Input, OnInit } from '@angular/core';
import { User } from 'src/app/shared/models/gql/user.model';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Component({
  selector: 'app-agreement-need-more-help-form',
  templateUrl: './agreement-need-more-help-form.component.html',
  styleUrls: ['./agreement-need-more-help-form.component.scss'],
})
export class AgreementNeedMoreHelpFormComponent implements OnInit {
  /** Coordinator data for agreement */
  @Input() otherUser: Partial<User>;

  /** The organisation name */
  @Input() organisationName: string;

  /** Show the heading and service guide link section  */
  @Input() isHeadingSectionVisible = true;

  constructor(private utilityService: UtilityService) {}

  ngOnInit(): void {
    // If there is no organisation name override, use the business name on the user
    if (!this.organisationName) {
      this.organisationName = this.otherUser?.organisation?.businessName;
    }
  }

  /**
   * Open service agreementguide
   */
  protected serviceAgreementGuide(): void {
    this.utilityService.openExternalLink(
      'https://mable.com.au/discover/support-worker-guide-to-mable/what-to-include-in-a-service-agreement/',
    );
  }
}
